import type { ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import Sidebar, { SIDEBAR_WIDTH } from './Sidebar'

interface Props {
  isAdmin?: boolean
  onSignOut?: () => void
  children: ReactNode
}

/** Routes where the sidebar is hidden for a full-width immersive view */
const IMMERSIVE_ROUTES = ['/new-job', '/workspace']

export default function AuthenticatedLayout({ isAdmin, onSignOut, children }: Props) {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const isImmersive = IMMERSIVE_ROUTES.some(r => pathname.startsWith(r))

  return (
    <>
      {isImmersive ? (
        <div className="px-4 pt-4">
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg font-mono text-xs text-slate-500 hover:text-cyan-400 bg-white/[0.03] hover:bg-white/[0.06] border border-cyan-500/10 hover:border-cyan-500/30 transition-all duration-150"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Home
          </button>
        </div>
      ) : (
        <Sidebar isAdmin={isAdmin} onSignOut={onSignOut} />
      )}
      <div style={{ marginLeft: isImmersive ? 0 : SIDEBAR_WIDTH }}>
        {children}
      </div>
    </>
  )
}
